/* 链接操作工具函数 */

import { isDefined } from './util'
import qs from 'qs'
export function toPdfPreviewUrl(url) {
  return `/tk-online/assets/pdf/web/viewer.html?file=${encodeURIComponent(url)}`
}
export function isUrl(url) {
  return /^htt(p|ps):\/\//.test(url)
}

export function addParamsToUrl(url = '', params = {}, addToHash = false) {
  const hashpos = url.indexOf('#')
  let hash = ''
  let path = url
  let search = ''
  if (hashpos >= 0) {
    hash = url.slice(hashpos)
    path = url.slice(0, hashpos)
  }
  let str = addToHash ? hash : path
  const cururlparams = (str && getQueryJson(str)) || {}
  params = {
    ...cururlparams,
    ...params
  }
  const serachPos = path.indexOf('?')
  if (serachPos >= 0) {
    search = path.slice(serachPos)
    path = path.slice(0, serachPos)
  }

  addToHash ? (hash = hash.split('?')[0]) : (search = '')
  str = ''
  Object.keys(params).forEach(key => {
    if (params[key]) {
      str += '&' + key + '=' + params[key]
    }
  })
  if (str) {
    str = '?' + str.slice(1)
    if (addToHash) {
      hash = hash + str
    } else {
      search = str
    }
  }
  return path + search + hash
}

/**
 * 拼接参数字符串给当前链接
 * @param {object} params 参数集
 * @param {string} url 源链接，默认取location.href
 * @param {string} exclude 要屏蔽的属性，用逗号分隔，例如分享他人时需要传入 'openid,unionId,userInfo'
 */
export function reputUrl({ params = {}, url, exclude }) {
  if (!url) {
    url = location.href
  }
  const object = {}
  const options = {
    addQueryPrefix: true,
    sort: (a, b) => a.localeCompare(b),
    skipNulls: true
  }
  // 存在exclude且为string类型
  if (exclude && typeof exclude === 'string') {
    exclude = exclude.toLowerCase()
  } else {
    exclude = false
  }
  const keys = Object.keys(params)

  for (const key of keys) {
    const value = params[key]
    // 参数值非空且key不在exclude字符串中
    if (
      value !== '' &&
      value !== undefined &&
      value !== null &&
      exclude &&
      !exclude.includes(key.toLowerCase())
    ) {
      object[key] = value
    }
  }
  const paramsStr = qs.stringify(object, options)
  return url.split('?')[0] + paramsStr
}

/**
 * getQueryString  从url中拿参数值param
 * @param {str} param 要拿的参数名  字符
 * @param {str} url  要从什么链接上面拿参数  字符  支持密文  可选填
 * @return {str} 参数值
 */
export function getQueryString(param, url) {
  let searchUrl = window.location.href
  if (url) {
    searchUrl = url.indexOf('?') ? url.substr(url.indexOf('?')) : searchUrl
  }
  const reg = new RegExp('(^|&|\\?)' + param + '=([^&]+)(&|$)', 'i')
  const r = searchUrl.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2]) || ''
  }
  return ''
}

/**
 * 从页面url中获取json（url是未被编码的明文格式）
 * <pre>url格式：http://www.baidu.com?action=1&toobar=0
 * @param {str} url  页面的url, 选传, 默认当前页面地址（url是未被编码的明文格式）
 * @returns {obj} json    json对象
 */
export function getQueryJson(url) {
  const json = {}
  const urlStr = isDefined(url) ? url : location.href
  const splits = urlStr.split('?')
  if (splits && splits.length >= 2) {
    const array = splits[1].split('&')
    if (array && array.length > 0) {
      for (let i = 0; i < array.length; i++) {
        const params = array[i].split('=') // 拆分形式为key=value形式的参数
        json[params[0]] = params[1] // 第一个参数表示key，第二个参数表示value
      }
    }
  }
  return json
}
